import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    subkind?: "numbers";
    isLast?: boolean;
    showBottomBorder?: boolean;
}

export const Root = styled.tr<RootProps>(
    props => ({
        color: theme(props).tables.headers.smallFont.color,
    }),
    props =>
        props.subkind === "numbers"
            ? {
                  verticalAlign: "middle",
                  textAlign: "center",
                  borderBottom: "none",
                  "> td": {
                      lineHeight: "22px",
                  },
                  td: {
                      padding: 0,
                  },
              }
            : props.isLast && {
                  "> td": {
                      paddingBottom: 10,
                  },
              },
    props =>
        props.showBottomBorder && {
            borderBottom: theme(props).tables.border.solid,
        }
);
